/**
** JAVASCRIPTS
** Name: Dealer
********************************************************************************/


/**
** Pre-imports
****************************************/

import * as L from 'leaflet';


/**
** Scripts
****************************************/

(function() {


  if(document.querySelector('.js-business') && document.querySelector('.js-business-map')) {


    /**
    ** Variables
    ****************************************/

    const $business = document.querySelector('.js-business');
    const $map      = $business.querySelector('.js-business-map');


    /**
    ** FUNCTION
    ** Set Map
    ****************************************/

    function setMap() {


      /**
      ** Variables
      ****************************************/

      const iconUrl = $map.dataset.marker;
      const lat     = $map.dataset.lat;
      const lng     = $map.dataset.lng;

      var markerIcon = L.icon({
        iconUrl:      iconUrl,
        shadowUrl:    false,
        iconSize:     [40, 40],
        shadowSize:   [0, 0],
        iconAnchor:   [20, 39],
        shadowAnchor: [0, 0],
        popupAnchor:  [0, -40]
      });

      var map    = L.map('map').setView([lat, lng], 16);
      var marker = L.marker([lat, lng], {icon: markerIcon}).addTo(map);


      /**
      ** Set tiles
      ***************************************/

      var OpenStreetMap_Mapnik = L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      });

      OpenStreetMap_Mapnik.addTo(map);


    }


    /**
    ** Init
    ****************************************/

    // if(window.innerWidth >= 960) {
      setMap();
    // }


  }

})();
